module.exports = __webpack_public_path__ + "img/zk-icon-scene.fef1c8f0.svg";